import React from 'react';
import '../footer/Footer.css'
import FI from '../../assets/ACM-FOOTER.png'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFacebook, faLinkedinIn, faXTwitter, faYoutube } from '@fortawesome/free-brands-svg-icons';
import { faMapMarkerAlt, faEnvelope } from '@fortawesome/free-solid-svg-icons';



function Footer() {
  return (
    <footer>

      {/* web-view */}

      <div className='Footer web-view'>
        <img src={FI} alt='footer-image' className='FI' />
        <div className='f-allign'>
          <div className='Quick_Links'>
            <h4>Quick links</h4>
            <ul>
              <li><a href="/">Home</a></li>
              <li><a href="/About ACM">About ACM</a></li>
              <li><a href="/Board">Community</a></li>
              <li><a href="/Resources">Events</a></li>
              <li><a href="/gallery">Gallery</a></li>
            </ul>
          </div>

          <div className='contact-us'>
            <h4>Connect</h4>
            <ul>
              <li><a href="mailto:kareacmw@klu.ac.in"> <FontAwesomeIcon icon={faEnvelope} /> kareacmw@klu.ac.in</a></li>
            </ul>
          </div>

          <div className='follow'>
            <h4>Follow Us</h4>
            <ul>
              <li><a href="https://www.linkedin.com/in/kare-acm-w-student-chapter-8212b8320" target='_blank'><FontAwesomeIcon icon={faLinkedinIn} /> LinkedIn</a></li>
              <li><a href="https://www.facebook.com/share/Rmq2dZXKTUvmmUGb/?mibextid=qi2Omg" target='_blank'><FontAwesomeIcon icon={faFacebook} /> Facebook</a></li>
              <li><a href="https://www.youtube.com/@ACM-WSTUDENTCHAPTERKARE" target='_blank'><FontAwesomeIcon icon={faYoutube} /> Youtube</a></li>
            </ul>
          </div>
        </div>
        <div className="footer-bottom">
          <p>Developed by <a style={{ textDecoration: 'none', color: 'white' }} href="https://www.linkedin.com/in/sathuragiri22" target="_blank" rel="Linkedin">Sathuragiri</a> & <a style={{ textDecoration: 'none', color: 'white' }} href="https://www.linkedin.com/in/PThavamani" target="_blank" rel="noopener noreferrer">Thavamani</a></p>
        </div>
      </div>

      {/* mobile-view */}

      <div className='Footer mobile-view'>
        <img src={FI} alt='footer-image' className='FI' />
        <div className='f-allign'>
          <div className='Quick_Links'>
            <h4>Quick links</h4>
            <ul>
              <li><a href="/">Home</a></li>
              <li><a href="/About ACM">About ACM</a></li>
              <li><a href="/Board">Community</a></li>
              <li><a href="/Resources">Events</a></li>
              <li><a href="/gallery">Gallery</a></li>
            </ul>
          </div>

          <div className='contact-us'>
            <h4>Connect</h4>
            <ul>
              <li><a href="mailto:kareacmw@klu.ac.in"> <FontAwesomeIcon icon={faEnvelope} /> kareacmw@klu.ac.in</a></li>
            </ul>
          </div>

          <div className='follow'>
            <h4>Follow Us</h4>
            <ul>
              <li><a href="https://www.linkedin.com/in/kare-acm-w-student-chapter-8212b8320#"><FontAwesomeIcon icon={faLinkedinIn} /> LinkedIn</a></li>
              <li><a href="https://www.facebook.com/share/Rmq2dZXKTUvmmUGb/?mibextid=qi2Omg"><FontAwesomeIcon icon={faFacebook} /> Facebook</a></li>
              <li><a href="https://www.youtube.com/@ACM-WSTUDENTCHAPTERKARE"><FontAwesomeIcon icon={faYoutube} /> Youtube</a></li>
            </ul>
          </div>
        </div>
        <div className="footer-bottom">
          <p>Developed by <a style={{ textDecoration: 'none', color: 'white' }} href="https://www.linkedin.com/in/sathuragiri22" target="_blank" rel="Linkedin">Sathuragiri</a> & <a style={{ textDecoration: 'none', color: 'white' }} href="https://www.linkedin.com/in/PThavamani" target="_blank" rel="noopener noreferrer">Thavamani</a></p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
